import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import useMobileMetadata from '../../hooks/QueryMenuMobile1'
import useMobileMetadata2 from '../../hooks/QueryMenuMobile2'
import useMobileMetadata3 from '../../hooks/QueryMenuMobile3'
import flatListToHierarchical from '../../util/flatListToHierarchical'
import { device } from '../Breakpoints'

const MobileNavigation = styled.div`
  @media ${device.mobileL} {
    display: block;
  }
  form {
    background: #ff8f8c;
    padding: 0.5em 1em;
    position: relative;
    svg {
      position: absolute;
      top: 11px;
      left: 24px;
      z-index: 999999;
      font-size: 1.7em;
    }
    input {
      border-radius: 50px;
      border: 1px solid #ffffff;
      padding: 0.7em 2.5em;
      color: #ffffff;
      background: transparent;
      width: 100%;
      box-sizing: border-box;
      ::placeholder {
        color: #ffffff;
      }
    }
    @media ${device.laptop} {
      display: block;
    }
  }
  nav {
    display: block;
    background: #499490;
    position: absolute;
    width: 100%;
    z-index: 9998;
    .inactive .submenu {
      display: none;
    }
    li:first-child.active {
      margin: -18px -18px 0;
      padding: 0.9em 3.8em;
      box-shadow: inset 0px 4px 7px #043c38;
    }
    .active {
      background: #1d716b;
      padding: 0.9em 3em;
      > button {
        svg {
          transform: rotate(90deg);
        }
      }
      > .submenu {
        display: block;
      }
    }
    .links {
      ul {
        margin: 0;
        padding: 1em 0em;
        border-bottom: 1px solid #ffffff;
        :last-child {
          border: none;
        }
        li {
          padding: 0em 3em;
          button {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            background: transparent;
            border: none;
            svg {
              font-size: 1.7em;
            }
          }
          ul.submenu {
            margin: 0;
            border-top: 1px solid #ffffff;
            padding: 0;
            li {
              padding: 0em 0em;
              .submenu {
                padding: 15px;
                margin-bottom: 15px;
                border-top: 1px solid #419690;
                border-bottom: 1px solid #419690;
              }
              a {
                text-transform: none;
              }
              button {
                text-transform: none;
              }
            }
          }
        }
      }
      a {
        display: flex;
        justify-content: space-between;
        align-items: center;
        svg {
          font-size: 1.7em;
        }
      }
    }
    li {
      list-style: none;
    }
    a,
    button {
      color: #ffffff;
      text-transform: uppercase;
      text-decoration: none;
      font-size: 0.8em;
      display: block;
      padding: 1em;
    }
  }
  ul.social {
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 4px 4px 6px #2c736f;
    a {
      background: #ffffff;
      color: #148581;
      font-size: 1.7em;
      padding: 0.4em;
      min-height: 34px;
    }
  }
`

const MenuMobile = () => {
  const menuMobile1 = useMobileMetadata()
  const menuMobileFlat = flatListToHierarchical(menuMobile1)
  const menuMobile2 = useMobileMetadata2()
  const menuMobileFlat2 = flatListToHierarchical(menuMobile2)
  const menuMobile3 = useMobileMetadata3()
  const menuMobileFlat3 = flatListToHierarchical(menuMobile3)
  const [active, setActive] = useState('')
  const [activeChild, setActiveChild] = useState('')

  function click(submenu) {
    if (active === submenu) {
      setActive('')
    } else {
      setActive(submenu)
    }
  }
  function clickChild(submenu) {
    if (activeChild === submenu) {
      setActiveChild('')
    } else {
      setActiveChild(submenu)
    }
  }
  return (
    <>
      <MobileNavigation>
        <nav>
          <div className="links">
            <ul>
              {menuMobileFlat.map(item => (
                <li
                  key={item.order}
                  className={active === item.order ? 'active' : 'inactive'}
                >
                  {item.url === '#' ? (
                    <button
                      type="button"
                      onClick={() => click(item.order)}
                      className={item.url.replace('/', ' ')}
                    >
                      {item.label}
                      {item.childItems.nodes.length !== 0 && <FiChevronRight />}
                    </button>
                  ) : (
                    <Link to={item.url} state={{ area: item.label }}>
                      {item.label}
                      <FiChevronRight />
                    </Link>
                  )}
                  {item.childItems.nodes.length !== 0 ? (
                    <ul id={item.order} className="submenu">
                      {item.childItems.nodes.map(child => (
                        <li
                          key={child.order}
                          className={
                            activeChild === child.order ? 'active' : 'inactive'
                          }
                        >
                          {child.url.charAt(0) === '/' ? (
                            <Link state={{ area: item.label }} to={child.url}>
                              {child.label}
                              {child.childItems.nodes.length !== 0 && (
                                <FiChevronDown />
                              )}
                            </Link>
                          ) : child.url === '#' ? (
                            <button
                              type="button"
                              onClick={() => clickChild(child.order)}
                              className={child.url.replace('/', ' ')}
                            >
                              {child.label}
                              {child.childItems.nodes.length !== 0 ? (
                                <FiChevronDown />
                              ) : (
                                ''
                              )}
                            </button>
                          ) : (
                            <a
                              href={child.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {child.label}
                            </a>
                          )}
                          {child.childItems.nodes.length !== 0 ? (
                            <ul className="submenu">
                              {child.childItems.nodes.map(child2 => (
                                <li key={child2.order}>
                                  {child.url.charAt(0) === '/' ? (
                                    <Link
                                      state={{ area: item.label }}
                                      to={child2.url}
                                    >
                                      {child2.label}
                                    </Link>
                                  ) : (
                                    <a
                                      href={child2.url}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {child2.label}
                                    </a>
                                  )}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ''
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    ''
                  )}
                </li>
              ))}
            </ul>
            <ul>
              {menuMobileFlat2.map(item => (
                <li key={item.order}>
                  {item.url === '#' ? (
                    <button
                      type="button"
                      className={item.url}
                      onClick={() => click(item.order)}
                    >
                      {item.label}
                      {item.childItems.nodes.length !== 0 ? (
                        <FiChevronRight />
                      ) : (
                        ''
                      )}
                    </button>
                  ) : (
                    <Link state={{ area: item.label }} to={item.url}>
                      {item.label}
                      <FiChevronRight />
                    </Link>
                  )}
                  {item.childItems.nodes.length !== 0 ? (
                    <ul
                      id={item.order}
                      className={
                        active === item.order
                          ? 'submenu active'
                          : 'submenu inactive'
                      }
                    >
                      {item.childItems.nodes.map(child => (
                        <li key={child.order}>
                          <Link state={{ area: child.label }} to={child.url}>
                            {child.label}
                            {child.childItems.nodes.length !== 0 && (
                              <FiChevronDown />
                            )}
                          </Link>
                          {child.childItems.nodes.length !== 0 ? (
                            <ul className="submenu">
                              {child.childItems.nodes.map(child2 => (
                                <li key={child2.order}>
                                  <Link
                                    state={{ area: child2.label }}
                                    to={child2.url}
                                  >
                                    {child2.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ''
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    ''
                  )}
                </li>
              ))}
            </ul>
            <ul>
              {menuMobileFlat3.map(item => (
                <li key={item.order}>
                  {item.url === '#' ? (
                    <button
                      type="button"
                      className={item.url}
                      onClick={() => click(item.order)}
                    >
                      {item.label}
                      {item.childItems.nodes.length !== 0 ? (
                        <FiChevronRight />
                      ) : (
                        ''
                      )}
                    </button>
                  ) : (
                    <Link state={{ area: item.label }} to={item.url}>
                      {item.label}
                      <FiChevronRight />
                    </Link>
                  )}
                  {item.childItems.nodes.length !== 0 ? (
                    <ul
                      id={item.order}
                      className={
                        active === item.order
                          ? 'submenu active'
                          : 'submenu inactive'
                      }
                    >
                      {item.childItems.nodes.map(child => (
                        <li key={child.order}>
                          <Link state={{ area: child.label }} to={child.url}>
                            {child.label}
                            {child.childItems.nodes.length !== 0 && (
                              <FiChevronDown />
                            )}
                          </Link>
                          {child.childItems.nodes.length !== 0 ? (
                            <ul className="submenu">
                              {child.childItems.nodes.map(child2 => (
                                <li key={child2.order}>
                                  <Link
                                    state={{ area: child2.label }}
                                    to={child2.url}
                                  >
                                    {child2.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ''
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    ''
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </MobileNavigation>
    </>
  )
}

export default MenuMobile
